import React from "react";
import Pagetitle from "../elements/Pagetitle";

const aboutContent = {
  name: "Salim",
  avatarImage: "/images/profil_f.png",
  content:
      (<p>
          <p>
              I am an AI Research Scientist (VP) at
              <a href="https://www.jpmorgan.com/technology/artificial-intelligence"> J.P. Morgan AI Research</a>,
              where my work focuses on developing methods to estimate and adapt machine learning performance under
              distribution shifts, both in batch and online settings. I also work on inference-time adaptation and steering of large
              language models (LLMs).
          </p>
          <p> More broadly, my research aims to enhance the reliability and trustworthiness of machine learning models.
              My core areas of interest include:</p>
            <ul>
                <li style={{ color: 'rgb(250, 77, 96)' }}>Domain Adaptation & Distribution Shift</li>
                <li style={{ color: 'rgb(250, 77, 96)' }}>LLM Safety</li>
                <li style={{ color: 'rgb(250, 77, 96)' }}>Online Learning</li>
                <li style={{ color: 'rgb(250, 77, 96)' }}>Uncertainty Quantification (Conformal Prediction)</li>
                <li style={{ color: 'rgb(250, 77, 96)' }}>Explainability Techniques</li>
            </ul>

          <p>
              Previously, I completed my Ph.D. in Statistics/Machine Learning at
              <a href="https://www.universite-paris-saclay.fr/en"> University Paris Saclay</a> in collaboration with
              <a href="https://www.stellantis.com/en"> Stellantis</a>, advised by
              <a href="https://publons.com/researcher/1205159/nicolas-j-b-brunel"> Nicolas Brunel </a>
              (ENSIIE, University Paris Saclay, <a href="https://www.quantmetry.com/"> Quantmetry</a>)
              and <a href="https://fr.linkedin.com/in/olaf-kouamo-76642a38">Olaf Kouamo</a> (Stellantis).
          </p>

          <p> During my Ph.D., I identified several limitations in existing explainable AI methods and introduced more
              theoretically sound, computationally efficient approaches. I also developed distribution-free uncertainty
              quantification methods or conformal prediction techniques.
          </p>

          <p>
              Prior to my Ph.D., I earned an M.Sc. in Statistics/Machine Learning from the Mathematics Master’s program
              at <a href="https://m2stat.sorbonne-universite.fr/">Sorbonne University</a>. As part of my training,
              I interned at the <a href="https://www.dassault.fr/subsidiaries/dassault-systemes">Dassault Systèmes </a>
              Research Laboratory in Paris, where I investigated unsupervised deep learning techniques for generating
              and editing 3D objects. I also completed an early master’s thesis in Probability at the
              <a href="https://www.lpsm.paris/laboratoire/pr%C3%A9sentation/"> Laboratoire de Probabilités, Statistique
                  et Modélisation (LPSM) </a>,
              under the supervision of <a href="https://www.lpsm.paris/pageperso/bergerq/">Quentin Berger</a>,
              studying branching random walks.
          </p>
      </p>),
};

function About() {
    return (
        <section id="about">
            <div className="container">
                <Pagetitle title="About Me"/>
                <div className="row">
                    <div className="col-md-4">
                        <div className="">
                            <img src={aboutContent.avatarImage} alt={aboutContent.name}/>
                        </div>
                        <div className="spacer d-md-none d-lg-none" data-height="30"></div>
                    </div>

                    <div className="col-md-8">
                        <div className="about-content-container rounded bg-white shadow-dark padding-30">
                            <div className="about-text">
                                {aboutContent.content}
                            </div>
                            <div className="about-cta mt-4">
                                <a href="https://drive.google.com/file/d/1opUm9NgkEcEM8lxS41LTQ635FC6O1tXL/view?usp=sharing"
                                   className="btn btn-default">
                                    Download CV
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;
